import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { StationHours } from '@app/services/station.interface';
import { formatTime } from '@app/shared/utils';
import { daysOfWeek, WEEKDAYS } from '@app/shared/utils/consts';
import { AddMissingChargerHoursEditDialogComponent } from '../add-missing-charger-hours-edit-dialog/add-missing-charger-hours-edit-dialog.component';

@Component({
  selector: 'app-add-missing-charger-hours-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './add-missing-charger-hours-dialog.component.html',
  styleUrl: './add-missing-charger-hours-dialog.component.scss'
})
export class AddMissingChargerHoursDialogComponent {
  dialogRef = inject(MatDialogRef<AddMissingChargerHoursDialogComponent>);
  hours: StationHours = {
    dayHours: {
      SUN: [{}],
      MON: [{}],
      TUE: [{}],
      WED: [{}],
      THU: [{}],
      FRI: [{}],
      SAT: [{}],
    },
    open24Hours: false,
  };
  daysOfWeek = daysOfWeek;
  WEEKDAYS = WEEKDAYS;
  formatTime = formatTime;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { hours: StationHours }
  ) {
    if (data.hours) {
      this.hours = data.hours;
    }
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({
      hours: this.hours,
    });
  }

  getWeekDay(day: number) {
    return WEEKDAYS[daysOfWeek[day]];
  }

  openEditHourDialog(days: string[]) {
    const dialogRef = this.dialog.open(AddMissingChargerHoursEditDialogComponent, {
      maxWidth: '560px',
      width: '560px',
      height: '490px',
      data: {
        hours: JSON.parse(JSON.stringify(this.hours)),
        days: days,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.hours) {
        this.hours = result?.hours;
      }
    });
  }
}
